import { ROOT_SECURITY_GROUP_ID } from "@/constants/geotabGroupIds";
import { GroupIndex, isUnderBranch } from "@/utilities/groupIndex";

/** Built-in clearances (root, Administrator, Supervisor, …) all carry this id suffix. */
const BUILT_IN_CLEARANCE_SUFFIX = "SecurityId";

export function isProtectedClearanceId(id: string) {
  return id.endsWith(BUILT_IN_CLEARANCE_SUFFIX);
}

interface ClearanceCandidate {
  id: string;
  name?: string;
  children?: { id: string }[];
}

export function filterClearanceOptions<T extends ClearanceCandidate>(
  source: T[],
  index: Pick<GroupIndex, "parentById">,
): T[] {
  return source
    .filter(
      group =>
        isProtectedClearanceId(group.id) ||
        isUnderBranch(index, group.id, ROOT_SECURITY_GROUP_ID),
    )
    .sort((a, b) => (a.name ?? a.id).localeCompare(b.name ?? b.id));
}

export function buildClearanceSetEntity<T extends ClearanceCandidate & { comments?: string }>(
  fullClearance: T,
  name: string,
  comments: string,
): T {
  return { ...fullClearance, name: name.trim(), comments };
}
